import { render, staticRenderFns } from "./BodyExpensesAnalysis.vue?vue&type=template&id=63e46c62&scoped=true"
import script from "./BodyExpensesAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyExpensesAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyExpensesAnalysis.vue?vue&type=style&index=0&id=63e46c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e46c62",
  null
  
)

export default component.exports